"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUL = exports.StyledNav = exports.StyledLI = exports.StyledHead = exports.StyledH1 = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledNav = _styledComponents.default.div.withConfig({
  displayName: "Navigationstyles__StyledNav",
  componentId: "sc-8aoy8p-0"
})(["background:", ";padding:10px;&.horizontal{ul{display:flex;li{", ";position:relative;font-size:16px;line-height:19px;padding:0px 14px;.count{margin-left:7px;}&:first-child{padding-left:0px;}&:last-child{padding-right:0px;}&.has-child{ul{flex-direction:column;position:absolute;left:0px;}}}}}&.vertical{.level-0{li{padding:17px 0px;a,span{font-family:", ";}}}li.has-child{&.expanded{padding-bottom:0px;span{color:", ";font-family:", ";}}ul{padding:15px 0px 10px 15px;li{padding:15px 0px;}}}}"], _shared.theme.palette.ui.neutral.grey5, _shared.theme.typography.h5.css, _shared.theme.typography.body.fontFamily, _shared.theme.palette.brand.primary.charcoal, _shared.theme.typography.body.fontFamily);

exports.StyledNav = StyledNav;

const StyledUL = _styledComponents.default.ul.withConfig({
  displayName: "Navigationstyles__StyledUL",
  componentId: "sc-8aoy8p-1"
})(["list-style:none;margin:0px;padding:0px;z-index:9;li.has-child{ul{display:none;}&.expanded{ul{display:block;}}}"]);

exports.StyledUL = StyledUL;

const StyledLI = _styledComponents.default.li.withConfig({
  displayName: "Navigationstyles__StyledLI",
  componentId: "sc-8aoy8p-2"
})(["font-size:18px;font-family:", ";&.active{a,span{color:", ";&:after{content:'';display:block;height:2px;background-color:", ";position:absolute;bottom:-8px;width:100%;}svg{fill:", ";}}}&.disabled{cursor:no-drop;pointer-events:none;a,span{color:", ";}svg{fill:", ";}}&:hover,&:hover a,&:hover span{color:", ";}&:hover{svg{fill ", ";}}&.has-child:hover{ul > li.active > *{color:", ";}ul > li > *{color:", ";}ul > li:hover > *{color:", ";}}a{text-decoration:none;color:", ";display:inline-block;position:relative;}span{color:", ";cursor:pointer;svg{position:relative;left:18px;fill:", ";}}"], _shared.theme.typography.link.fontFamily, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.cta.blue, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.neutral.grey7, _shared.theme.palette.ui.neutral.grey7, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.gray);

exports.StyledLI = StyledLI;

const StyledHead = _styledComponents.default.div.withConfig({
  displayName: "Navigationstyles__StyledHead",
  componentId: "sc-8aoy8p-3"
})(["padding-bottom:24px;"]);

exports.StyledHead = StyledHead;

const StyledH1 = _styledComponents.default.h1.withConfig({
  displayName: "Navigationstyles__StyledH1",
  componentId: "sc-8aoy8p-4"
})(["color:", ";margin:0px;padding:0px;font-size:24px;line-height:29px;"], _shared.theme.palette.brand.primary.charcoal);

exports.StyledH1 = StyledH1;